module.exports = __webpack_public_path__ + "static/media/customer-info-process.36844ac2.svg";